import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/contexts/auth-context';
import { DashboardLayout as DashboardLayoutComponent } from '@/components/layouts/dashboard-layout';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import { LoadingSpinner } from '@/components/LoadingSpinner';

// Import dashboard pages
import DashboardHome from './dashboard/DashboardHome';
import DepartmentsPage from './dashboard/DepartmentsPage';
import StatesPage from './dashboard/StatesPage';
import DistrictsPage from './dashboard/DistrictsPage';
import BlocksPage from './dashboard/BlocksPage';
import IndicatorsPage from './dashboard/IndicatorsPage';
import UsersPage from './dashboard/UsersPage';
import SettingsPage from './dashboard/SettingsPage';
import IndicatorData2Page from './dashboard/IndicatorData2Page';
import BlockIndicatorsPage from './dashboard/BlockIndicatorsPage';
import DistrictIndicatorsPage from './dashboard/DistrictIndicatorsPage';

export default function DashboardLayout() {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return <LoadingSpinner fullScreen text="Authenticating..." />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <DashboardLayoutComponent>
      <Suspense fallback={<LoadingSpinner text="Loading page..." />}>
        <Routes>
          <Route 
            path="/" 
            element={
              <RouteErrorBoundary routeName="Dashboard Home">
                <DashboardHome />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/departments" 
            element={
              <RouteErrorBoundary routeName="Departments">
                <DepartmentsPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/states" 
            element={
              <RouteErrorBoundary routeName="States">
                <StatesPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/districts" 
            element={
              <RouteErrorBoundary routeName="Districts">
                <DistrictsPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/blocks" 
            element={
              <RouteErrorBoundary routeName="Blocks">
                <BlocksPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/indicators" 
            element={
              <RouteErrorBoundary routeName="Indicators">
                <IndicatorsPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/users" 
            element={
              <RouteErrorBoundary routeName="Users">
                <UsersPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/indicator-data" 
            element={
              <RouteErrorBoundary routeName="Indicator Data">
                <IndicatorData2Page />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/indicator-data/district/:districtId/indicators" 
            element={
              <RouteErrorBoundary routeName="District Indicators">
                <DistrictIndicatorsPage />
              </RouteErrorBoundary>
            } 
          />
          
          <Route 
            path="/indicator-data/block/:blockId/indicators" 
            element={
              <RouteErrorBoundary routeName="Block Indicators">
                <BlockIndicatorsPage />
              </RouteErrorBoundary>
            } 
          />
          <Route 
            path="/settings" 
            element={
              <RouteErrorBoundary routeName="Settings">
                <SettingsPage />
              </RouteErrorBoundary>
            } 
          />
        </Routes>
      </Suspense>
    </DashboardLayoutComponent>
  );
}
